module.exports = __webpack_public_path__ + "static/media/04.8d11b7f7.png";